import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
  const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    children: [
      {
        //Parametrizacion de la Evaluacion no en uso
        path: '/parametrizacion',
        component: () => import(/* webpackChunkName: "Parametrizacion" */ '../views/Parametrizacion.vue')
      },
      {
        //Evaluacion de desempeño inicial no en uso
        path: '/desempeno',
        component: () => import(/* webpackChunkName: "Desempeno" */ '../views/DesempenoUser.vue')
      },
      {
        //Vista donde estan los graficos
        path: '/dash',
        component: () => import(/* webpackChunkName: "Dash" */ '../views/Dash.vue')
      },
      {
        //Debe ser la vista de la evaluacion de desempeño por parte del supervisor
        path: '/desempenosup',
        component: () => import(/* webpackChunkName: "DesemplenoSup" */ '../views/DesempenoSup.vue')
      },
      {
        //Muestra las instituciones acceso sys
        path: '/instituciones',
        component: () => import(/* webpackChunkName: "Instituciones" */ '../views/Instituciones.vue')
      },
      {
        //Muestra usuarios de institucion acceso adm
        path: '/usuarios',
        component: () => import(/* webpackChunkName: "Usuarios" */ '../views/Usuarios.vue')
      },
      {
        //Master de usuarios admin y sys
        path: '/sysusr',
        component: () => import(/* webpackChunkName: "Usuarios" */ '../views/SysUser.vue')
      },
      {
        //Master de evaluaciones acceso adm
        path: '/evaluaciones',
        component: () => import(/* webpackChunkName: "Evaluaciones" */ '../views/Evaluaciones.vue')
      },
      {
        //Carga Masiva de Colaboradores
        path: '/masivo',
        component: () => import(/* webpackChunkName: "CargaMasiva" */ '../views/Masivo.vue')
      },      
      {
        //Muestra la evaluacion como tal acceso usr
        path: '/evaluacion/:id',
        component: () => import(/* webpackChunkName: "Evaluacion" */ '../views/Evaluacion.vue')
      },
      {
        //Muestra la evaluacion como tal acceso usr
        path: '/evaluacion/:id/:idcol',
        component: () => import(/* webpackChunkName: "Evaluacion" */ '../views/Evaluacion.vue')
      },
      {
        //Muestra la evaluacion para parametrizar adicionales usuarios admin
        path: '/evaluacionadm/:id',
        component: () => import(/* webpackChunkName: "Evaluacion" */ '../views/EvaluacionAdm.vue')
      },
      {
        //Master de Competencias
        path: '/competencias',
        component: () => import(/* webpackChunkName: "Evaluacion" */ '../views/Competencias.vue')
      },
      {
        //Master de Competencias
        path: '/competenciasmasivo',
        component: () => import(/* webpackChunkName: "Evaluacion" */ '../views/MasivoCom.vue')
      },
      {
        //Master de Objetivos
        path: '/objetivos',
        component: () => import(/* webpackChunkName: "Evaluacion" */ '../views/Objetivos.vue')
      },
      {
        //Master de Objetivos
        path: '/objetivosmasivo',
        component: () => import(/* webpackChunkName: "Evaluacion" */ '../views/MasivoObj.vue')
      },
      {
        //Master de Evaluaciones
        path: '/evaluacionesmasivos',
        component: () => import(/* webpackChunkName: "Evaluacion" */ '../views/MasivoEval.vue')
      },      
      {
        //Master de Reportes
        path: '/reportes',
        component: () => import(/* webpackChunkName: "Evaluacion" */ '../views/Reportes.vue')
      }
    ]
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    children: [
      {
        path: '/otro',
        component: () => import(/* webpackChunkName: "otro" */ '../views/Otro.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'Log',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
